export default __webpack_public_path__ + "static/media/image-ph-health-home-w.598ff9d4.png";